import React from 'react';
import { FormControl, InputAdornment, TextField } from '@mui/material';
import { Lock, DateRange } from '@mui/icons-material';
import { FormFieldFooter } from '../Error';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';

export const DateTimePickerField = ({
  input,
  label,
  meta: { touched, error },
  fullWidth,
  className,
  disabled,
  description,
  InputProps,
  minDate,
  inputVariant,
}: any) => {
  const getEndAdornment = () => {
    if (disabled) {
      return (
        <InputAdornment position="end">
          <Lock />
        </InputAdornment>
      );
    }
    return (
      <InputAdornment position="end">
        <DateRange />
      </InputAdornment>
    );
  };

  return (
    <FormControl variant="standard" fullWidth={fullWidth} className={className}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={label}
          value={input.value || null}
          onChange={date => input.onChange(date)}
          minDate={minDate}
          disabled={disabled}
          renderInput={params => (
            <TextField
              {...params}
              variant={inputVariant || 'filled'}
              margin="normal"
              error={!!touched && !!error}
              helperText={touched && error ? error : null}
              onBlur={input.onBlur}
              InputProps={{
                ...params.InputProps,
                ...(InputProps || {}),
                endAdornment: getEndAdornment(),
              }}
            />
          )}
          // The 'format' prop is not supported in v5 DatePicker.
          // Formatting is handled by the date adapter.
          // The 'clearable' prop is also not supported.
          // A custom clear button can be implemented if needed.
        />
      </LocalizationProvider>
      <FormFieldFooter
        touched={touched}
        error={error}
        description={description}
      />
    </FormControl>
  );
};
